import { Tooltip } from '@shared/components/popover/tooltip';
import { preciseCurrencyFormatter } from '@shared/helpers/format-currency';
import { effectivePrice, hasPromoPrice, type Product } from '../../../data/product';
import { StatusCell } from '../../status/status-cell';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Price: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Price',
  minWidth: 75,
  accessorFn: (product) => preciseCurrencyFormatter(effectivePrice(product)),
  cell: ({ item: product, value }) => (
    <span className="inline-flex w-full items-center justify-between gap-1">
      <span>{value}</span>
      {hasPromoPrice(product) && (
        <Tooltip
          content={`Currently selling at promo price ${preciseCurrencyFormatter(effectivePrice(product))}. Regular price ${preciseCurrencyFormatter(product.price)}.`}
        >
          <StatusCell variant="info" shape="circle">
            P
          </StatusCell>
        </Tooltip>
      )}
    </span>
  ),
  toCSV: (product) => ({
    Price: effectivePrice(product).toFixed(2),
  }),
});
